import React from 'react';
import { Modal, Form, Input, Select, DatePicker, Button } from 'antd';
import styles from './index.less';

const { Option } = Select;

interface CreateTeamModalProps {
  visible: boolean;
  onCancel: () => void;
  onOk: (values: any) => void;
}

const JoinTeamModal: React.FC<CreateTeamModalProps> = ({ visible, onCancel, onOk }) => {
  const [form] = Form.useForm();

  const handleOk = async () => {
    try {
      const values = await form.validateFields(); // 表单校验
      const result: any = await onOk(values); // 调用父组件的 onOk 方法并等待结果

      console.log('接口调用成功', result);

      if (result === true) {
        form.resetFields(); // 清空表单
        onCancel(); // 关闭弹窗
      } 
    } catch (error) {
      console.error('表单验证失败或接口调用失败:', error);
    }
  };

  const handleCancel = () => {
    form.resetFields(); // 关闭时重置表单
    onCancel();
    
  }
  return (
    <Modal
      title={null}
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width="90%"
      style={{ top: '5%'}}
      destroyOnClose
      wrapClassName={styles.createTeamModal}
      maskClosable={false} // 关键设置：点击遮罩不关闭
    >
      <div className={styles.modalContent}>
        {/* 左侧内容 */}
        <div className={styles.leftContent}>
          <h2>加入团队</h2>
          <p >
          加入团队可将个人账号绑定至项目专属隔离工作空间，凭管理员提供的邀请码提交申请，审核通过后参与团队标注工作。
          </p>
          <img
            src="./images/createTeambg.png"
            alt="加入团队"
            style={{ marginTop: '20px', width: '100%', height: 'auto' }}
          />
        </div>

        {/* 右侧表单 */}
        <div className={styles.rightContent}>
          <Form form={form} layout="vertical">
            <Form.Item
              label="邀请码"
              name="code"
              rules={[{ required: true, message: '请输入邀请码' }]}
            >
              <Input placeholder="请输入邀请码" />
            </Form.Item>

      

            <div className={styles.buttonGroup}>
              <Button onClick={handleCancel}>取消</Button>
              <Button type="primary" onClick={handleOk}>
                确定
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </Modal>
  );
};

export default JoinTeamModal;